export default function AutoSaveHint({ pending, valid, saved, error }: {
  pending: boolean
  valid: boolean
  saved: boolean
  error: string | null
}) {
  const notSaved = error !== null || !valid || !saved
  const status = pending ? 'Сохраняем изменения…' : notSaved ? 'Не сохранено' : 'Изменения сохранены.'
  return <p role="status" className={`mt-4 text-[13px] ${notSaved && !pending ? 'text-st-unpaid' : 'text-ink-muted'}`}>{status}</p>
}
